export const formatSwissPhoneNumber = (value: string) => {
  return value.replace(/(\d{2})(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
}

export const formatNumber = (value: number, digits = 2) => (value ?? 0).toLocaleString('de-CH', {
  maximumFractionDigits: digits,
  minimumFractionDigits: digits,
});
